module.exports = __webpack_public_path__ + "static/media/eliminar.52c6c97c.svg";